<template>
  <article class="contents-content">
    <div class="contents-content__content">
      <div class="content-in-area">
        <h1 class="content__title with--button">담당자 관리 - 담당자 {{ mode === 'CREATE' ? '등록' : '수정' }}
          <v-btn v-if="$store.state.userInfo && ($store.state.userInfo.writeParking || $store.state.userInfo.writeBus)" depressed rounded outlined color="secondary" class="ml-2"  @click="setCreateMode">
            <v-icon>add</v-icon> 담당자 추가
          </v-btn>
        </h1>
        <v-container>
          <v-row>
            <nav class="content-left-menu">
              <transition name="fade">
                <div v-if="managerList && managerList.length > 0">
                  <ul
                    class="content-menu-list"
                    ref="contentMenu"
                  >
                    <li
                      v-for="(manager, idx) in managerList"
                      :key="manager.id"
                      :class="['content-menu__item', {'is--active' : activeIndex === idx}]"
                      @click="setCurrentManager(manager)"
                    >
                      <strong
                        class="menu__item-main"
                        @click="selectMainItem(idx)"
                      >
                        {{ manager.name }}
                      </strong>
                    </li>
                  </ul>
                </div>
                <p class="content--empty" v-if="managerList && managerList.length === 0">등록된 담당자가 없습니다.</p>
              </transition>
            </nav>
            <div class="content--has-menu">
              <v-card outlined class="content__content">
                <v-card-text>
                  <v-form
                    ref="form"
                    v-if="manager && manager.id || mode === 'CREATE'"
                  >
                    <v-container>
                      <v-row class="pa-2">
                        <v-col cols="10" class="pa-0">
                          <v-text-field
                            v-model="manager.name"
                            prepend-icon="person"
                            label="이름"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="10" class="pa-0">
                          <v-text-field
                            prepend-icon="call"
                            v-model="manager.phone"
                            label="연락처"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="10" class="pa-0">
                          <v-checkbox
                            v-model="manager.invisible"
                            label="앱에서 숨기기(비공개)"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col class="text-center mb-2">
                          <v-btn
                            v-if="$store.state.userInfo && ($store.state.userInfo.writeParking || $store.state.userInfo.writeBus)"
                            :disabled="!(manager.name || '').trim()"
                            color="primary"
                            rounded
                            class="mt-4"
                            depressed
                            @click="onSubmit"
                            large
                          >
                            {{ mode === 'CREATE' ? '등록하기' : '수정하기'}}
                          </v-btn>
                        </v-col>
                     </v-row>
                      <v-row>
                        <v-col class="mt-2">
                          <v-btn
                            color="error"
                            v-if="$store.state.userInfo && ($store.state.userInfo.writeParking || $store.state.userInfo.writeBus) && manager.id"
                            depressed
                            rounded
                            outlined
                            dark
                            @click="onRemoveManager">
                            <v-icon>remove</v-icon>
                            담당자제거
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                  <p v-else class="content--empty">선택된 담당자가 없습니다.</p>
                </v-card-text>
              </v-card>
            </div>
          </v-row>
        </v-container>
      </div>
    </div>
  </article>
</template>

<script>
import { manager } from '../api'
import eventBus from '../utils/eventBus'
export default {
  components: {
  },
  data: () => ({
    managerList: null,
    manager: {
      id: 0,
      name: '',
      phone: '',
      invisible: false
    },
    mode: null,
    valid: true,
    activeIndex: null
  }),
  created () {
    this.fetchList()
  },
  methods: {
    async fetchList () {
      const { data } = await manager.list()
      this.managerList = data
    },
    async createManager () {
      const { data } = await manager.create(this.manager)
      eventBus.$emit('alert', { active: true, text: '등록 되었습니다.' })
      await this.fetchList()
      this.setCurrentManager(data)
      this.activeIndex = this.managerList.findIndex(x => x.id === data.id)
    },
    async updateManager () {
      await manager.set(this.manager.id, this.manager)
      eventBus.$emit('alert', { active: true, text: '수정 되었습니다.' })
      await this.fetchList()
    },
    setCreateMode () {
      this.manager = { invisible: false }
      this.mode = 'CREATE'
      this.activeIndex = null
    },
    setCurrentManager (manager) {
      this.manager = { ...manager }
      this.mode = 'UPDATE'
    },
    async onSubmit () {
      try {
        eventBus.$emit('showLoading')
        if (this.mode === 'CREATE') {
          await this.createManager()
        } else {
          await this.updateManager()
        }
      } catch (e) {
        eventBus.$emit('alert', { active: true, text: '에러!' })
      } finally {
        eventBus.$emit('hideLoading')
      }
    },
    async onRemoveConfirm () {
      await manager.delete(this.manager.id)
      eventBus.$emit('alert', { active: true, text: '제거되었습니다.' })
      this.setCreateMode()
      await this.fetchList()
      this.isOpen = false
    },
    selectMainItem (index) {
      this.activeIndex = index
    },
    onRemoveManager () {
      eventBus.$emit('dialog',
        {
          active: true,
          msg: '담당자를 정말 제거하시겠습니까?',
          okText: '담당자제거',
          confirmHandler: {
            ok: () => {
              this.onRemoveConfirm()
            }
          }
        }
      )
    }
  }
}
</script>

<style lang="scss">
</style>
